export default "__VITE_ASSET__CnjuySTB__"